module.exports = __webpack_public_path__ + "img/curation_img.e56e61b9.png";